export const EVENT_PAGESLIDER_ITEMS_LOADED = 'pageslider-items-loaded';
